import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {action, observable} from 'mobx';
import StudioPlayerTrackArc from './StudioPlayerTrackArc';
import StudioPlayerTrackLegoArc from './StudioPlayerTrackLegoArc';
import {tau} from './studioUtility';
import {disabledLight} from '../../../themes/colors';

@inject('studioStore', 'looperStore', 'mainStore')
@observer
class StudioPlayerTrack extends Component {
    @observable splits;

    @action componentDidMount() {
        this.splits = this.props.track.splits;
    }

    @action componentWillUpdate(nextProps) {
        this.splits = nextProps.track.splits;
    }

    handler = () => {
    };

    setRef = (g) => {
        this.g = g;
    };

    render() {
        const {track, tier, onDragStart, onDragEvent, onDragEnd, calculateAngles,
            onTrimStart, onTrim, onTrimEnd, onSnap, onSnapEnd, onSelected, onSplitSelect, globalDuringDrag, studioStore, looperStore, mainStore, mobileView} = this.props;
        const {absBeatCount, beatCount, leaderTrack} = studioStore;


        const fillColor = track.volume !== 0 ? track.color : disabledLight;
        return (
            <g ref={this.setRef}
                className={track.isSelectAll ? 'stroke-track' : ''}>

                {!this.splits && tier % 2 === 0 && <StudioPlayerTrackArc tier={tier} beatCount={beatCount} startAngle={0} endAngle={tau}
                    className={`studio-grid-arc-bg fill ${leaderTrack.duration === 0 ? 'empty' : ''}`} mobileView={mobileView}
                    onClick={this.handler} onDoubleClick={this.handler}
                    withCorner={!mobileView} fillColor={mobileView ? '#f8f8f8' : 'transparent'} />
                }

                {this.splits && this.splits.map((split, i) => {
                    let minStartBeat = 0;
                    let maxEndBeat = beatCount;
                    if (i > 0) {
                        const prevSplit = this.splits[i - 1];
                        minStartBeat = (prevSplit.rightTrim || prevSplit.end) + prevSplit.offset;
                    }
                    if (i + 1 < this.splits.length) {
                        const nextSplit = this.splits[i + 1];
                        maxEndBeat = (nextSplit.leftTrim || nextSplit.start) + nextSplit.offset;
                    }

                    return (<StudioPlayerTrackLegoArc key={`${split.start}_${split.end}_${split.offset}_${split.leftTrim}_${split.rightTrim}`}
                        index={i} split={split} mobileView={mobileView}
                        track={track} leaderTrack={leaderTrack} absBeatCount={absBeatCount}
                        trackLength={looperStore.looperTracks.length}
                        finishStemsAnimation={mainStore.finishStemsAnimation}
                        beatCount={beatCount} tier={tier}
                        fillColor={fillColor}
                        minStartBeat={minStartBeat}
                        maxEndBeat={maxEndBeat}
                        calculateAngles={calculateAngles}
                        onClick={onSplitSelect}
                        onDragStart={onDragStart} onDragEnd={onDragEnd}
                        onDragEvent={onDragEvent}
                        onTrimStart={onTrimStart} onTrim={onTrim} onTrimEnd={onTrimEnd}
                        onSnap={onSnap} onSnapEnd={onSnapEnd}
                        onSelected={onSelected} globalDuringDrag={globalDuringDrag}
                        wave={track.wave} downloadPct={track.downloadPct}/>);
                })}
            </g>
        );
    }
}


StudioPlayerTrack.propTypes = {
    track: PropTypes.object,
    tier: PropTypes.number,
    onSplitSelect: PropTypes.func,
    onDragStart: PropTypes.func,
    onDragEvent: PropTypes.func,
    onDragEnd: PropTypes.func,
    onTrimStart: PropTypes.func,
    onTrim: PropTypes.func,
    onTrimEnd: PropTypes.func,
    onSnap: PropTypes.func,
    onSnapEnd: PropTypes.func,
    onSelected: PropTypes.func,
};

export default StudioPlayerTrack;
